/**
 * Date and time utility functions for form validation
 */

/**
 * Get current date in YYYY-MM-DD format for date input min attribute
 */
export const getTodayDateString = (): string => {
  return new Date().toISOString().split("T")[0];
};

/**
 * Get minimum datetime (30 minutes from now) in YYYY-MM-DDTHH:MM format
 */
export const getMinDateTime = (): string => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 30);
  return now.toISOString().slice(0, 16);
};

/**
 * Get minimum time for today (30 minutes from now) in HH:MM format
 */
export const getMinTimeForToday = (): string => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 30);
  return now.toTimeString().slice(0, 5);
};

/**
 * Check if selected date is today
 */
export const isToday = (dateString: string): boolean => {
  const today = new Date().toISOString().split("T")[0];
  return dateString === today;
};

/**
 * Validate if the selected date and time is at least 30 minutes from now
 */
export const isValidDateTime = (date: string, time: string): boolean => {
  if (!date || !time) return false;

  const selectedDateTime = new Date(`${date}T${time}`);
  const minDateTime = new Date();
  minDateTime.setMinutes(minDateTime.getMinutes() + 30);

  return selectedDateTime >= minDateTime;
};

/**
 * Format date and time for display
 */
export const formatDateTime = (
  date: string,
  time: string,
  locale: string = "en",
  atWord: string = "at"
): string => {
  if (!date || !time) return "";

  const dateObj = new Date(`${date}T${time}`);
  const dateOptions: Intl.DateTimeFormatOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };

  // Use English by default, but allow for localization
  const dateLocale = locale === "nl" ? "nl-NL" : "en-US";
  const formattedDate = dateObj.toLocaleDateString(dateLocale, dateOptions);
  const formattedTime = dateObj.toLocaleTimeString(dateLocale, timeOptions);

  // Return formatted date with translated "at" word
  return `${formattedDate} ${atWord} ${formattedTime}`;
};
